import { createRoot } from 'react-dom/client'
import React, { lazy, Suspense } from 'react'

import { MaterialIcon } from '@/core/components/material-icon'

const ClientPageRoot = lazy(() => import('./index'))

export const mountClientPage = () => {
  const featured_video_clips_root = document.getElementById(
    'featured-video-clips',
  )

  if (featured_video_clips_root) {
    createRoot(featured_video_clips_root).render(
      <Suspense
        fallback={
          <div className="flex justify-center">
            <MaterialIcon
              icon={'progress_activity'}
              className="text-primary animate-spin"
              size={48}
            />
          </div>
        }
      >
        <ClientPageRoot />
      </Suspense>,
    )
  }
}
